import Vue from 'vue'
import VueRouter from 'vue-router'

// Layouts
import AppLayout from '@/layouts/AppLayout'
import RouteWrapper from '@/layouts/RouteWrapper'

// Components
import Evaluations from '@/views/evaluations/Evaluations'
import UserAssignments from '@/views/evaluations/user/UserAssignments'
import ProfessorAssignments from '@/views/evaluations/professor/ProfessorAssignments'
import ChallengedEvaluations from '@/views/challenged_evaluations/ChallengedEvaluations'
import ViewSubmission from '@/views/assignments/ViewSubmission'
import SSO from '@/views/authentication/SSO'
import NotificationsPage from '@/views/Notifications/NotificationsPage'

import { getAuthInfo } from '@/utils/helpers'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'sso',
    component: SSO,
    beforeEnter: (to, from, next) => {
      if (getAuthInfo()) {
        next({
          name: 'Home',
        })
      }
      next()
    },
  },

  // {
  //   path: '/reset-password',
  //   name: 'ResetPassword',
  //   component: ResetPassword,
  //   beforeEnter: (to, from, next) => {
  //     if (getAuthInfo()) {
  //       next({
  //         name: 'Home',
  //       })
  //     }
  //     next()
  //   },
  // },
  // {
  //   path: '/app/reset/:uid/:token',
  //   name: 'SetPassword',
  //   component: SetPassword,
  //   beforeEnter: (to, from, next) => {
  //     if (getAuthInfo()) {
  //       next({
  //         name: 'Home',
  //       })
  //     }
  //     next()
  //   },
  // },
  {
    path: '/home',
    component: AppLayout,
    beforeEnter: (to, from, next) => {
      if (!getAuthInfo()) {
        next({
          name: 'sso',
        })
      }
      next()
    },
    children: [
      {
        name: 'Home',
        path: '',
        redirect: { name: 'ListEvaluations' },
      },
      {
        path: 'evaluations',
        component: RouteWrapper,
        children: [
          {
            name: 'ListEvaluations',
            path: 'list',
            meta: { hideBackButton: true },
            component: Evaluations,
          },
          {
            name: 'ListChallengedEvaluations',
            path: 'challenged/list',
            meta: { hideBackButton: true },
            component: ChallengedEvaluations,
          },
        ],
      },
      {
        path: 'users',
        component: RouteWrapper,
        children: [
          {
            name: 'UserAssignments',
            path: 'view/:userId',
            component: UserAssignments,
          },
        ],
      },
      {
        path: 'professors',
        component: RouteWrapper,
        children: [
          {
            name: 'ProfessorAssignments',
            path: 'view/:professorId',
            component: ProfessorAssignments,
          },
        ],
      },
      {
        path: 'submissions',
        component: RouteWrapper,
        children: [
          {
            name: 'ViewSubmission',
            path: 'view/:submissionId',
            component: ViewSubmission,
          },
        ],
      },
      {
        name: 'Notifications',
        path: 'notifications',
        component: NotificationsPage,
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

export default router
